import { Button, Checkbox, Divider, Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { Calendar, CheckSquare, Hash, Type } from 'react-feather'
import { useSpreadSheetData } from '../../SpreadSheetDataProvider'
import { setFilters } from '../../SpreadSheetDataProvider/actions'
import BooleanFilter from './BooleanFilter'
import DateFilter from './DateFilter'
import NumberFilter from './NumberFilter'
import StringFilter from './StringFilter'
{ TabPane } = Tabs


AttributeFilter = ({ column }) ->

  [booleanFilter, setBooleanFilter] = useState(undefined)
  [stringFilter, setStringFilter] = useState(undefined)
  [{ filters }, dispatch] = useSpreadSheetData()

  onOk = (type, val) ->
    return unless type? and val?
    dispatch(
      setFilters({
        filters...
        [column.key]: { type, val }
      })
    )

  <div
    onClick={(e) -> e.stopPropagation()}
    onMouseMove={(e) -> e.stopPropagation()}
    onMouseUp={(e) -> e.stopPropagation()}
  >
    <Tabs defaultActiveKey="1">
      <TabPane tab={<Type data-testid="#{column.key}-string-filter" />} key="1">
        <StringFilter onOk={onOk} />
      </TabPane>
      <TabPane tab={<CheckSquare data-testid="#{column.key}-boolean-filter" />} key="2">
        <BooleanFilter onOk={onOk} columnKey={column.key} />
      </TabPane>
      <TabPane tab={<Hash data-testid="#{column.key}-double-filter" />} key="3">
        <NumberFilter onOk={onOk} />
      </TabPane>
      <TabPane tab={<Calendar data-testid="#{column.key}-date-filter" />} key="4">
        <DateFilter onOk={onOk} />
      </TabPane>
    </Tabs>
    <Divider style={{ margin: '12px 0' }} />
    <Button
      data-testid="#{column.key}-clear-filters-button"
      size="small"
      type="link"
      disabled={!filters[column.key]}
      onClick={ ->
        newFilters = { filters... }
        delete newFilters[column.key]
        dispatch(
          setFilters(newFilters)
        )
      }
    >Clear</Button>
  </div>

export default AttributeFilter
